const Icons = (props) => {
    const { icon, className, style } = props;

    return (
        <i className={`common-icon${icon ? ` ${icon}` : ""}${className ? ` ${className}` : ''}`} style={style}></i>
    )
}

export default Icons;